import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { get_latest_blogs } from '../store/reducers/blogReducer'
import { FaCalendar, FaArrowRight, FaClock, FaNewspaper } from 'react-icons/fa'

// Homepage bloq bölməsi — KOMPAKT (Option A: 4 bərabər kiçik kart).
// Ana səhifədə bir çox marketplace bölməsi var; bloq şaquli yer tutmamalıdır.
// /blogs səhifəsinin böyük kart dizaynı burada İSTİFADƏ OLUNMUR.

const CATEGORY_COLORS = {
    'Genel':      'bg-brand-100 text-brand-700',
    'Oyun':       'bg-blue-100 text-blue-700',
    'Rehber':     'bg-emerald-100 text-emerald-700',
    'Duyuru':     'bg-orange-100 text-orange-700',
    'Güncelleme': 'bg-purple-100 text-purple-700',
}

const stripHtml = (value = '') => String(value).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()

const HomeBlogSection = () => {
    const dispatch = useDispatch()
    const { latestBlogs } = useSelector(state => state.blog)

    useEffect(() => {
        dispatch(get_latest_blogs())
    }, [])

    const blogs = (latestBlogs || []).slice(0, 4)

    return (
        <section className='w-full max-w-marketplace mx-auto px-4 sm:px-4 md-lg:px-5 md:px-5 lg:px-8 py-8 sm:py-6'>
            {/* Başlıq sətri */}
            <div className='mb-5 flex flex-wrap items-end justify-between gap-3'>
                <div>
                    <span className='inline-flex items-center rounded-pill bg-brand-100 px-2.5 py-0.5 text-[10px] font-black uppercase tracking-wider text-brand-700'>
                        Bloq & Xəbərlər
                    </span>
                    <h2 className='mt-1.5 text-2xl font-black tracking-tight text-slate-900 sm:text-xl'>Blog & Xəbərlər</h2>
                    <p className='mt-0.5 text-sm text-slate-500'>E-ticarət, mağaza idarəçiliyi və rəqəmsal satışlar haqqında faydalı məqalələr.</p>
                </div>
                <Link to='/blogs' className='inline-flex shrink-0 items-center gap-1.5 text-sm font-bold text-brand-600 transition-colors hover:text-brand-700'>
                    Hamısına bax <FaArrowRight size={11} />
                </Link>
            </div>

            {blogs.length === 0 ? (
                /* Kompakt boş vəziyyət — böyük boşluq yaratmır */
                <div className='flex items-center gap-3 rounded-2xl border border-dashed border-brand-200 bg-white px-5 py-4'>
                    <span className='flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand-50 text-brand-500'><FaNewspaper size={16} /></span>
                    <div>
                        <p className='text-sm font-bold text-slate-700'>Hələ bloq paylaşımı yoxdur</p>
                        <p className='text-xs text-slate-400'>Yeni məqalələr tezliklə əlavə olunacaq.</p>
                    </div>
                </div>
            ) : (
                <div className='grid grid-cols-4 gap-4 md-lg:grid-cols-2 sm:grid-cols-1'>
                    {blogs.map((blog) => (
                        <Link
                            key={blog._id || blog.slug}
                            to={`/blog/${blog.slug}`}
                            className='group flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-brand-200 hover:shadow-md'
                        >
                            {/* Kompakt şəkil sahəsi */}
                            <div className='relative h-28 shrink-0 overflow-hidden bg-slate-100 sm:h-32'>
                                {blog.image
                                    ? <img src={blog.image} alt={`${stripHtml(blog.title)} - ItemZo Blog`} loading='lazy' onError={(e) => { e.currentTarget.style.display = 'none' }} className='h-full w-full object-cover transition-transform duration-300 group-hover:scale-105' />
                                    : <div className='flex h-full w-full items-center justify-center bg-gradient-to-br from-brand-100 via-brand-50 to-orange-50 text-3xl'>📰</div>}
                                <span className={`absolute left-2 top-2 rounded-pill px-2 py-0.5 text-[10px] font-bold ${CATEGORY_COLORS[blog.category] || 'bg-brand-100 text-brand-700'}`}>
                                    {blog.category}
                                </span>
                            </div>

                            <div className='flex flex-1 flex-col p-3.5'>
                                <h3 className='line-clamp-2 text-[13px] font-bold leading-snug text-slate-800 transition-colors group-hover:text-brand-700'>
                                    {blog.title}
                                </h3>
                                {blog.summary && (
                                    <p className='mt-1 line-clamp-1 text-xs text-slate-500'>{stripHtml(blog.summary)}</p>
                                )}
                                <div className='mt-auto flex items-center justify-between gap-2 pt-2.5 text-[11px] text-slate-400'>
                                    <span className='inline-flex items-center gap-1'>
                                        <FaCalendar size={9} />
                                        {new Date(blog.createdAt).toLocaleDateString('az-AZ')}
                                    </span>
                                    {blog.readTime > 0 && (
                                        <span className='inline-flex items-center gap-1 font-semibold text-orange-500'>
                                            <FaClock size={9} /> {blog.readTime} dəq
                                        </span>
                                    )}
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </section>
    )
}

export default HomeBlogSection
